(function () {
  var entry = document.querySelector('[data-matiere-entry]');

  if (!entry) {
    return;
  }

  var start = entry.querySelector('[data-entry-start]');
  var showPinButton = entry.querySelector('[data-show-pin]');
  var pinForm = entry.querySelector('[data-pin-form]');
  var pinInput = entry.querySelector('[data-pin-input]');
  var pinDots = Array.prototype.slice.call(entry.querySelectorAll('[data-pin-dot]'));
  var pinKeys = Array.prototype.slice.call(entry.querySelectorAll('[data-pin-key]'));

  function updateDots() {
    var value = pinInput.value;

    pinDots.forEach(function (dot, index) {
      dot.classList.toggle('is-filled', index < value.length);
    });
  }

  function setPin(value) {
    pinInput.value = value.replace(/\D/g, '').slice(0, 6);
    updateDots();
  }

  if (showPinButton && pinForm && pinInput) {
    showPinButton.addEventListener('click', function () {
      if (start) {
        start.hidden = true;
      }

      pinForm.hidden = false;
      pinInput.focus();
    });
  }

  if (pinInput) {
    pinInput.addEventListener('input', function () {
      setPin(pinInput.value);
    });
  }

  pinKeys.forEach(function (button) {
    button.addEventListener('click', function () {
      var key = button.getAttribute('data-pin-key');
      var current = pinInput.value;

      if (key === 'clear') {
        setPin('');
        return;
      }

      if (key === 'del') {
        setPin(current.slice(0, -1));
        return;
      }

      setPin(current + key);
    });
  });

  updateDots();
})();
